import "alpinejs";
import Alpine from "alpinejs";
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import "lazysizes";
import "../pcss/styles.pcss";
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import loadjs from "loadjs";
import { getCookie, setCookie } from "tiny-cookie";
import { gsap, TweenMax, Quart, Power1, Linear } from "gsap";
import {
  divMaker,
  divMover,
  imgMaker,
  duplicate,
} from "./tools/animation-tools.js";
import { getRandomInt } from "./tools/misc.js";

Alpine.plugin(focus);
Alpine.plugin(collapse);

// Form-alpinsjs component
Alpine.data('contactForm', () => {
    return {
        sending: false,
        success: false,

        async submitForm() {
            this.sending = true;

            const formData = new FormData(this.$refs.form);

            try {
                const response = await fetch(this.$refs.form.action, {
                    method: 'POST',
                    body: formData,
                });

                if (response.ok) {
                    this.success = true;

                    // Wait for 5 secs
                    setTimeout(() => {
                        this.resetFormFields();
                        this.success = false;
                    }, 5000);
                } else {

                    console.error('Could not send the message');
                }
            } catch (err) {
                console.error('Network error:', err);
            } finally {
                this.sending = false;
            }
        },

        resetFormFields() {
            const elements = this.$refs.form.querySelectorAll('input, textarea, select');
            elements.forEach(el => {
                if (el.type === 'checkbox' || el.type === 'radio') {
                    el.checked = false;
                } else {
                    el.value = '';
                }
            });
        }
    };
});

Alpine.data('newsPagination', (perPage, total) => ({
    page: 1,
    perPage: perPage,
    total: total,

    get totalPages() {
        return Math.max(1, Math.ceil(this.total / this.perPage));
    },

    isVisible(index) {
        const start = (this.page - 1) * this.perPage;
        return index >= start && index < start + this.perPage;
    },

    prev() {
        if (this.page > 1) {
            this.page--;
        }
    },

    next() {
        if (this.page < this.totalPages) {
            this.page++;
        }
    },
}));

window.onload = () => {
    document.querySelectorAll(".swiper").forEach((e) => {
        const interval = parseInt(e.dataset.autoplayInterval || "0", 10);
        const modules = [Navigation, Pagination];
        const config = {
            modules,
            direction: "horizontal",
            loop: true,
            spaceBetween: e.classList.contains("swiper-radius") ? 32 : 0,
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
                renderBullet: function(index, className) {
                    return `<span class="${className} !bg-white"></span>`;
                }
            },
            navigation: {
                nextEl: ".swipe-nextbt",
                prevEl: ".swipe-prevbt",
            }
        };
        if (interval > 0) {
            modules.push(Autoplay);
            config.autoplay = {
                delay: interval * 1000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            };
        }
        const swiper = new Swiper(e, config);

        if (interval > 0) {
            const pauseBtn = e.querySelector(".swiper-pause");
            if (pauseBtn) {
                const iconPause = pauseBtn.querySelector(".icon-pause");
                const iconPlay = pauseBtn.querySelector(".icon-play");
                let userPaused = false;
                const setPaused = (paused) => {
                    userPaused = paused;
                    pauseBtn.setAttribute("aria-pressed", String(paused));
                    pauseBtn.setAttribute("aria-label", paused ? "Spela bildspelet" : "Pausa bildspelet");
                    if (iconPause) iconPause.classList.toggle("hidden", paused);
                    if (iconPlay) iconPlay.classList.toggle("hidden", !paused);
                };
                pauseBtn.addEventListener("click", () => {
                    if (userPaused) {
                        setPaused(false);
                        swiper.autoplay.start();
                    } else {
                        setPaused(true);
                        swiper.autoplay.stop();
                    }
                });
                swiper.on("autoplayResume", () => {
                    if (userPaused) swiper.autoplay.stop();
                });
            }
        }
    })

    document.querySelectorAll(".hero-video-pause").forEach((btn) => {
        const hero = btn.closest(".hero-content") || btn.parentElement;
        const videos = hero.querySelectorAll("video");
        if (!videos.length) return;
        const iconPause = btn.querySelector(".icon-pause");
        const iconPlay = btn.querySelector(".icon-play");
        const setPaused = (paused) => {
            btn.setAttribute("aria-pressed", String(paused));
            btn.setAttribute("aria-label", paused ? "Spela videon" : "Pausa videon");
            if (iconPause) iconPause.classList.toggle("hidden", paused);
            if (iconPlay) iconPlay.classList.toggle("hidden", !paused);
        };
        btn.addEventListener("click", () => {
            const shouldPlay = videos[0].paused;
            videos.forEach((v) => {
                if (shouldPlay) {
                    v.play().catch(() => {});
                } else {
                    v.pause();
                }
            });
            setPaused(!shouldPlay);
        });
    });

    document.querySelectorAll('.main-navigation ul.grow > li.group > button').forEach((btn) => {
        btn.addEventListener("mousedown", (e) => e.preventDefault());
    });
}

// MrBanner-standard constz //
let mainTL, bWidth, bHeight, aniContainer;
// Loopsettings //
let currentLoop, maxLoops, bannerPaused;
// mr banner objects //
const mr = {};
// Kolla tiden: //
let bannerStart;

window.introAnimation = function() {
  return {
    mounted() {
      animation();
    },
  };
};

function animation() {
  loadjs(
    [
      "/assets/animation/solle.png",
      "/assets/animation/jasse.png",
      "/assets/animation/visby.png",
      "/assets/animation/baggelinjer.png",
      "/assets/animation/baggis.png",
      "/assets/animation/bron.png",
      "/assets/animation/masty.png",
      "/assets/animation/minecraft.png",
      "/assets/animation/tanky.png",
      "/assets/animation/torso.png",
      "/assets/animation/byggnader.png",
      "/assets/animation/lampz.png",
      "/assets/animation/lampy.png",
    ],
    {
      success() {
        bannerInit();
      },
      error(err) {
        console.error(err);
      },
    }
  );
}

function bannerInit() {
  bannerStart = new Date().getTime();

  aniContainer = document.getElementById("ani-container");
  bWidth = "100%";
  bHeight = 500;
  currentLoop = 0;
  maxLoops = 1000;

  mr.banner = divMaker({
    container: aniContainer,
    opacity: 0,
    position: "relative",
    display: "block",
    width: bWidth,
    height: bHeight,
    className: "mr-banner",
    background: "#2f80ab",
    overflow: "hidden",
  });

  mr.patternLayer = divMaker({
    container: mr.banner,
    top: 0,
    right: 0,
    width: 2500,
    height: bHeight,
    zIndex: 0,
    className: "pattern-layer",
  });

  mr.pattern = imgMaker({
    imgSrc: "/assets/animation/baggelinjer.png",
    className: "pattern",
    container: mr.patternLayer,
    top: -120,
    right: 0,
    width: 1250,
    height: "auto",
    zIndex: 2,
  });

  mr.pattern2 = duplicate(mr.pattern, mr.patternLayer, {
    top: -120,
    right: 1250,
    opacity: 1,
  });

  mr.layerStars = divMaker({
    container: mr.banner,
    top: 0,
    right: 0,
    width: 4000,
    height: "100%",
    zIndex: 2,
  });

  mr.layer0 = divMaker({
    container: mr.banner,
    top: 0,
    right: 0,
    width: 4000,
    height: "100%",
    zIndex: 2,
  });

  mr.layer1 = divMaker({
    container: mr.banner,
    top: 0,
    right: 0,
    width: 5125,
    height: "100%",
    zIndex: 3,
  });

  mr.layer2 = divMaker({
    container: mr.banner,
    top: 0,
    right: 0,
    width: 5125,
    height: "100%",
    className: "layer2",
    zIndex: 5,
  });

  mr.water = divMaker({
    container: mr.banner,
    bottom: 0,
    right: 0,
    width: "100%",
    height: 26,
    background: "#2f80ab",
    zIndex: 2,
  });

  mr.land = imgMaker({
    imgSrc: "/assets/animation/baggis.png",
    container: mr.layer0,
    bottom: 20,
    right: 0,
    width: 4000,
    height: "auto",
    zIndex: 2,
  });

  mr.lamplager = divMaker({
    container: mr.layer1,
    zIndex: 4,
    right: 0,
    height: "100%",
    width: "100%",
    bottom: 0,
    className: "lamplager",
  });

  mr.lampz = imgMaker({
    imgSrc: "/assets/animation/lampz.png",
    container: mr.lamplager,
    bottom: 10,
    right: 200,
    width: 3805,
    height: "auto",
    zIndex: 4,
    className: "lampz",
  });

  lampyGenerator(
    [580, 1200, 1803, 1957, 2119, 2477, 2698, 2913, 3067, 3220, 3300, 3890],
    mr.lamplager
  );

  mr.byggnader = imgMaker({
    imgSrc: "/assets/animation/byggnader.png",
    container: mr.layer1,
    bottom: 22,
    right: 850,
    width: 1900,
    height: "auto",
    zIndex: 2,
  });

  mr.euroSkrapor = duplicate(mr.byggnader, mr.layer2, {
    clip: "rect(0px 1150px 180px 810px)",
  });

  mr.torso = imgMaker({
    imgSrc: "/assets/animation/torso.png",
    container: mr.layer1,
    bottom: 25,
    right: 2860,
    width: 70,
    height: "auto",
    zIndex: 2,
    className: "torso",
  });

  mr.torsoTop = duplicate(mr.torso, mr.layer2, {
    clip: "rect(0px 90px 120px 0px)",
  });

  mr.kran = divMover({
    selector: "#krany svg",
    container: mr.layer0,
    bottom: 25,
    right: 2300,
    width: 230,
    height: "auto",
    zIndex: 4,
  });

  mr.masty = imgMaker({
    imgSrc: "/assets/animation/masty.png",
    container: mr.layer0,
    bottom: 30,
    right: 3050,
    width: 50,
    height: "auto",
    zIndex: 4,
  });

  mr.tanky = imgMaker({
    imgSrc: "/assets/animation/tanky.png",
    container: mr.layer0,
    bottom: 40,
    right: 3700,
    width: 185,
    height: "auto",
    zIndex: 2,
  });

  mr.bron = imgMaker({
    imgSrc: "/assets/animation/bron.png",
    container: mr.layer0,
    bottom: 25,
    right: 2300,
    width: 573,
    height: "auto",
    zIndex: 4,
  });

  mr.minecraft = imgMaker({
    imgSrc: "/assets/animation/minecraft.png",
    container: mr.layer0,
    bottom: 25,
    right: 2900,
    width: 120,
    height: "auto",
    zIndex: 4,
  });

  mr.jasse = imgMaker({
    imgSrc: "/assets/animation/jasse.png",
    container: mr.banner,
    top: 120,
    right: -200,
    width: 188,
    height: "auto",
    zIndex: 2,
    className: "jasse",
  });

  mr.stars = imgMaker({
    imgSrc: "/assets/animation/stars.png",
    container: mr.layerStars,
    className: "stars",
    top: 20,
    right: 1950,
    width: 1250,
    height: "auto",
    zIndex: 1,
  });

  mr.visby = imgMaker({
    imgSrc: "/assets/animation/visby.png",
    container: mr.layer1,
    bottom: 20,
    right: 3965,
    width: 366,
    height: "auto",
    className: "shippy",
    zIndex: 10,
  });

  mr.visby_copy = duplicate(mr.visby, mr.banner, { left: 0 });
  mr.solle = imgMaker({
    imgSrc: "/assets/animation/solle.png",
    container: mr.layer1,
    bottom: -200,
    right: 4150,
    width: 550,
    height: "auto",
    className: "solle",
    zIndex: 3,
  });

  initTimeline();
}

const lampyGenerator = function(xPosArr, lampyLayer) {
  for (const xPos of xPosArr) {
    const rndNum = getRandomInt(1, 10);
    let className = `blinky-${rndNum}`;
    let reflectClassName = `reflect-${rndNum}`;

    imgMaker({
      imgSrc: "/assets/animation/lampy.png",
      container: lampyLayer,
      right: xPos,
      bottom: 30.2,
      width: 10,
      className: className,
    });

    imgMaker({
      imgSrc: "/assets/animation/lampy.png",
      container: lampyLayer,
      right: xPos,
      opacity: 0.25,
      bottom: 10.2,
      width: 10,
      className: reflectClassName,
    });
  }
};

function initTimeline() {
  // fadeIn animation
  TweenMax.to(mr.banner, 0.2, { opacity: 1 });

  const scrollSpeed = 180;
  const aniStartPos = scrollSpeed * 0.4;

  let kranTL = gsap.timeline({ repeat: -1, yoyo: true });
  let kranpryl = document.querySelector('[data-name="kranpryl"]');
  let grej = document.querySelector('[data-name="grej"]');
  let vajer = document.querySelector('[data-name="vajer"]');

  kranTL.to(kranpryl, { duration: 2, x: -100, ease: Quart.easeInOut });
  kranTL.to(grej, { duration: 2, y: 40 });
  kranTL.to(vajer, { duration: 2, scaleY: 3.2 }, "-=2");
  kranTL.to(kranpryl, { duration: 4, x: 40, ease: Quart.easeInOut });
  kranTL.to(grej, { duration: 2, y: 0 });
  kranTL.to(vajer, { duration: 2, scaleY: 1 }, "-=2");

  TweenMax.to(".shippy", 2, {
    rotation: -2,
    y: 10,
    repeat: -1,
    yoyo: true,
    ease: Power1.easeInOut,
  });
  TweenMax.to(".solle", 4, {
    rotation: 1,
    y: 5,
    repeat: -1,
    yoyo: true,
    ease: Power1.easeInOut,
  });

  /* ### MAIN TIMELINE ### */
  mainTL = gsap.timeline({ paused: true, repeat: -1 });

  mainTL.fromTo(
    mr.layer1,
    { x: -1440 },
    { duration: scrollSpeed, x: "100%", ease: Linear.easeNone }
  );

  mainTL.fromTo(
    mr.layer2,
    { x: -1440 },
    { duration: scrollSpeed, x: "100%", ease: Linear.easeNone },
    0
  );
  mainTL.fromTo(
    mr.layer0,
    { x: -1440 },
    { duration: scrollSpeed, x: "100%", ease: Linear.easeNone },
    0
  );
  mainTL.fromTo(
    mr.layerStars,
    { x: -1440 },
    { duration: scrollSpeed, x: "80%", ease: Linear.easeNone },
    0
  );

  mainTL.to(
    mr.jasse,
    { duration: scrollSpeed / 4, x: -1650, y: -140, ease: Linear.easeNone },
    scrollSpeed * 0.65
  );
  mainTL.fromTo(
    mr.visby_copy,
    { x: -360 },
    { duration: scrollSpeed * 0.2, x: 1440, ease: Linear.easeNone },
    0
  );
  mainTL.play(aniStartPos);
}

window.cookieBanner = function() {
  return {
    cookiesIsOK: true,
    hideBanner() {
      setCookie("cookiebanner", 5, { expires: "365D", secure: true });
      this.cookiesIsOK = true;
    },
    mounted() {
      if (getCookie("cookiebanner") == "5") {
        this.cookiesIsOK = true;
      } else {
        this.cookiesIsOK = false;
      }
    },
  };
};

Alpine.start();
